import { useEffect } from "react";
import { useVisibleContainer } from "../hooks/useVisibleContainer";
import { loadAlbums } from "../../albumsApi";

// Route-effect component for "/add". Renders nothing - AddScreen.tsx
// (mounted unconditionally in AppRoot) owns the actual rendering into
// #addView, which this only shows/hides, same pattern as every other route
// screen (see GiftsRouteScreen.tsx). Reloads albums on mount so a direct
// nav/refresh straight to /add shows current destinations rather than
// whatever was last loaded elsewhere.
export function AddRouteScreen() {
  useVisibleContainer("addView");

  useEffect(() => {
    loadAlbums();
  }, []);

  return null;
}
